import { css as _css } from "@emotion/react";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { useTheme } from '@emotion/react';
import Tippy from '@tippyjs/react/headless';
import { motion, useAnimation } from 'framer-motion';
import { generateGradient } from '../assets/styles/utility/gradient';
import { getTransformOrigin } from '../helpers/utility';
import Button from './Button';
import Icon from './Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";

const Dropdown = _ref => {
  let {
    children,
    className,
    panelWidth = 250,
    placement = 'bottom',
    showArrow,
    trigger,
    wrapperStyles = {}
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children", "className", "panelWidth", "placement", "showArrow", "trigger", "wrapperStyles"]);

  const theme = useTheme();
  const dropdownPanelRef = React.useRef();
  const dropdownTriggerRef = React.useRef();
  const controls = useAnimation();
  const variants = {
    hidden: {
      opacity: 0,
      scale: 0.5
    },
    visible: {
      opacity: 1,
      scale: 1
    }
  };

  const handleOnMount = () => {
    dropdownTriggerRef.current.classList.add(theme.settings.classes.active);
    controls.start('visible');
  };

  const handleOnHide = async instance => {
    dropdownTriggerRef.current.classList.remove(theme.settings.classes.active);
    await controls.start('hidden');
    instance.unmount();
  };

  return ___EmotionJSX(Tippy, _extends({
    placement: placement,
    animation: true,
    onMount: handleOnMount,
    onHide: handleOnHide,
    onClickOutside: handleOnHide,
    trigger: "click",
    interactive: true,
    offset: [0, theme.space.base],
    render: attrs => ___EmotionJSX(motion.div, _extends({
      css: [{
        background: generateGradient({
          start: theme.color.light.base,
          stop: theme.color.panel.light,
          position: 'to bottom'
        }),
        padding: theme.space.large,
        width: panelWidth,
        maxHeight: 500,
        overflowY: 'auto',
        color: theme.fontColor.base,
        border: theme.border.base,
        borderRadius: theme.borderRadius.base,
        textAlign: 'left',
        zIndex: 10,
        boxShadow: theme.boxShadow.large,
        transformOrigin: attrs['data-placement'] && getTransformOrigin(attrs['data-placement'])
      }, wrapperStyles, process.env.NODE_ENV === "production" ? "" : ";label:Dropdown;"],
      className: `CK__Dropdown__Panel ${theme.settings.classes.trim}`,
      ref: dropdownPanelRef,
      variants: variants,
      animate: controls,
      initial: "hidden",
      transition: theme.motion.transition.base
    }, attrs), children)
  }, rest), ___EmotionJSX(Button, _extends({}, trigger.props, {
    ref: dropdownTriggerRef
  }), trigger.label, showArrow && ___EmotionJSX(Icon, {
    css: /*#__PURE__*/_css({
      marginLeft: theme.space.small,
      transition: `transform ${theme.timing.base} ${theme.transition.bounce}`,
      '.is-active &': {
        transform: 'rotate(180deg)'
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Dropdown;"),
    size: "small",
    icon: "caret-down"
  })));
};

export default Dropdown;